import React, { useEffect, useState } from "react";
import { Text, Flex, Bold, List, ListItem } from '@tremor/react';
import StarRating from "./star-rating";

const StarList = (props) => {
    
    const [totalReviews, setTotalReviews] = useState(0)
    let keys = Object.keys(props.data['data'])

    useEffect(()=>{

        let sum = 0;

        keys.forEach((key) => {
            // calculate total
            if(props.data['data'][key]['score'] && props.data['data'][key]['score'] > 0){
                sum += props.data['data'][key]['score']
            }
        })

        setTotalReviews(sum);

    },[keys])

    return (
        <>
        <Flex marginTop="mt-3">
            <Text><Bold>{'Score'}</Bold></Text>
            <Text><Bold>{'Count'}</Bold></Text>
        </Flex>
        <List>
        {
            keys && keys != {} && keys.map((key) => {
                if(props.data['data'][key]['score'] && props.data['data'][key]['score'] > 0){
                    return (
                        <ListItem>
                            <Flex>
                                <Text truncate={ true }><StarRating stars={key}/></Text>
                                <Text>{props.data['data'][key]['score']}</Text>
                            </Flex>
                        </ListItem>
                    )
                }
            })
        }
        </List>
        <Text>Total Reviews: {totalReviews}</Text>
        </>
    )
}



export default StarList;